import { render, staticRenderFns } from "./MPCTable.vue?vue&type=template&id=79c150e9&"
import script from "./MPCTable.vue?vue&type=script&lang=ts&"
export * from "./MPCTable.vue?vue&type=script&lang=ts&"
import style0 from "./MPCTable.vue?vue&type=style&index=0&id=79c150e9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports